/**
 * 团队用户设置模块
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Button,
} from 'antd';
import $ from 'jquery';
import {
    PlusOutlined,
    MinusOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    setStyle,
} from '../../incs/FunHelper.js';

import CNF from '../../incs/Config.js';

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [isRefreshUnselected, setIsRefreshUnselected] = useState(false);
    const [isRefreshSelected, setIsRefreshSelected] = useState(false);
    const [unselectedLists, setUnselectedLists] = useState([]);
    const [selectedLists, setSelectedLists] = useState([]);
    const [unselectedUsername, setUnselectedUsername] = useState('');
    const [selectedUsername, setSelectedUsername] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setUnselectedLists([]);
        setSelectedLists([]);
        setUnselectedUsername('');
        setSelectedUsername('');
    };

    useEffect(() => {
        if (props.open) {
            setIsRefreshUnselected(true);
            setIsRefreshSelected(true);
        }
    }, [props]);

    useEffect(() => {
        /**
         * 获取组未选择用户
         */
        const getUnselected = () => {
            let params = {
                'rss': 'unselected',
                'group_ulid': props.record.key,
                'username': unselectedUsername
            }
            $.ajax({
                url: `${CNF.api}users${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.res === 0) {
                    setUnselectedLists(data.dat);
                    setIsRefreshUnselected(false);
                }
            })
        }
        if (isRefreshUnselected) {
            getUnselected();
        }
    }, [props.record, isRefreshUnselected, unselectedUsername]);


    useEffect(() => {
        /**
         * 获取组已择用户
         */
        const getSelected = () => {
            let params = {
                'rss': 'selected',
                'group_ulid': props.record.key,
                'username': selectedUsername
            }
            $.ajax({
                url: `${CNF.api}users${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.res === 0) {
                    setSelectedLists(data.dat);
                    setIsRefreshSelected(false);
                }
            })
        }

        if (isRefreshSelected) {
            getSelected();
        }
    }, [props.record, isRefreshSelected, selectedUsername]);

    /**
     * 添加用户
     * @param {*} user_ulid 
     * @param {*} username 
     */
    const addUser = (user_ulid, username) => {
        setLoading(true);
        $.ajax({
            url: `${CNF.api}groups/${props.record.key}/user`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'user_ulid': user_ulid,
                'username': username,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                setIsRefreshUnselected(true);
                setIsRefreshSelected(true);
            }
        }).always(() => {
            setLoading(false);
        });
    }

    /**
     * 移除用户
     * @param {*} user_ulid 
     * @param {*} username 
     */
    const removeUser = (user_ulid, username) => {
        setLoading(true);
        $.ajax({
            url: `${CNF.api}groups/${props.record.key}/user`,
            headers: AddRequestHeaders(),
            type: 'DELETE',
            dataType: 'JSON',
            data: JSON.stringify({
                'user_ulid': user_ulid,
                'username': username,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                setIsRefreshUnselected(true);
                setIsRefreshSelected(true);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).always(() => {
            setLoading(false);
        });
    }

    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={'团队用户设置: ' + (props.record ? props.record.groupname : '')}
                open={props.open}
                onCancel={cancel}
                footer={null}
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={11}>
                        <Row>可选用户</Row>
                        <Row style={{ marginTop: CNF.rowMarginTop, }}>
                            <Col span={24}>
                                <Input
                                    onChange={(e) => {
                                        setUnselectedUsername(e.target.value.replace(/ /g, ''));
                                        if (e.target.value.replace(/ /g, '')) setIsRefreshUnselected(true);
                                    }}
                                    placeholder='用户名'
                                    value={unselectedUsername}
                                    disabled={false}
                                />
                            </Col>
                        </Row>
                        <div style={setStyle}>
                            {
                                props.open &&
                                unselectedLists.length > 0 &&
                                unselectedLists.map((item) => {
                                    return (
                                        <Row key={item['key']} style={{ width: '100%' }}>
                                            <Col span={20}>{item['username']}</Col>
                                            <Col span={2} offset={2}>
                                                <Button
                                                    color='primary'
                                                    variant='link'
                                                    title={CNF.actionName.ADD}
                                                    icon={<PlusOutlined />}
                                                    style={{ padding: 1 }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        addUser(item['key'], item['username'])
                                                    }}
                                                    disabled={loading}
                                                >
                                                </Button>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                        </div>
                    </Col>
                    <Col span={11} offset={2}>
                        <Row>已选用户</Row>
                        <Row style={{ marginTop: CNF.rowMarginTop, }}>
                            <Col span={24}>
                                <Input
                                    onChange={(e) => {
                                        setSelectedUsername(e.target.value.replace(/ /g, ''));
                                        if (e.target.value.replace(/ /g, '')) setIsRefreshSelected(true);
                                    }}
                                    placeholder='用户名'
                                    value={selectedUsername}
                                    disabled={false}
                                />
                            </Col>
                        </Row>
                        <div style={setStyle}>
                            {
                                props.open &&
                                selectedLists.length > 0 &&
                                selectedLists.map((item) => {
                                    return (
                                        <Row key={item['key']} style={{ width: '100%' }}>
                                            <Col span={20}>{item['username']}</Col>
                                            <Col span={2} offset={2}>
                                                <Button
                                                    color='primary'
                                                    variant='link'
                                                    title={CNF.actionName.REMOVE}
                                                    icon={<MinusOutlined />}
                                                    disabled={props.record.admin_user_ulid === item['key'] ? true : loading}
                                                    style={{ padding: 1 }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        removeUser(item['key'], item['username'])
                                                    }}
                                                >
                                                </Button>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity